import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download-v2-enabled",
  "use": "download-v2-enabled-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"download-v2-enabled\">\n    <path fill=\"#03ADEF\" fill-rule=\"evenodd\" d=\"M11 8h2.17L9 12.17 4.83 8H7V2h4v6zm1-7H6v6H2l7 7 7-7h-4V1zm4 15H2v1h14v-1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol